import { CurrencyISO } from '@guiker/money'
import { yup } from '@guiker/yup-util'
export const priceSchema = yup.object({
  amount: yup.number().required(),
  currency: yup.string().oneOf(Object.values(CurrencyISO)).required(),
})
